<script>
import load from '@/components/base/load';
export default {
    mixins: [load],
    name:'reportbase',
    data () {
        return {
            printCss:'@media print{body{-webkit-print-color-adjust:exact; -moz-print-color-adjust:exact;-ms-print-color-adjust:exact;print-color-adjust:exact;} @page {size: auto;margin: 0mm; }}',
            printName:'grid',
            exportName:'grid'
        };

    },
    methods:{
        print () {
            let  object = null;
            if (this.printName) {
                object = this.$refs[this.printName];
            }
            this.$Method.print(object,this.printCss);
        },
        export () {
            if (this.$refs[this.exportName].export) {
                this.$refs[this.exportName].export();
            }
        },
        module () {
            let modulecode = this.getModulecode();
            if (modulecode) {
                this.alert('模块号:' + modulecode);
            } else {
                this.alert('未设置模块号');
            } 
        },
        doAction (obj) {
            if (this[obj.name]) {
                this[obj.name]();
            }
        }
    }
   
};
</script>


// WEBPACK FOOTER //
// src/components/layout/reportbase.vue